import Badge from 'components/Badge';
import PropTypes from 'prop-types';
import React from 'react';
import { above } from 'utils/mediaqueries';
import styled from 'libs/styled';

const Wrapper = styled('div')`
    display: flex;
    flex-wrap: wrap;
    margin: -2px;

    ${above.sm} {
        margin: -3px;
    }
`;

const Badges = ({ badges = [], ...rest }) => (
    <Wrapper {...rest}>
        {badges.map(badge => (
            <Badge key={badge.text} theme={badge.theme}>
                {badge.text}
            </Badge>
        ))}
    </Wrapper>
);

Badges.propTypes = {
    badges: PropTypes.arrayOf(
        PropTypes.exact({
            text: PropTypes.string,
            theme: PropTypes.string,
        })
    ).isRequired,
};

export default Badges;
